import { atomWithStorage } from "jotai/utils";
import { CashAccounts } from "../types";
import { defaultCashAccounts } from "../functions/cashflow.ts";

/**
 * Current cash position: operating checking, the smoothing buffer that owner's
 * pay draws from, and the tax set-aside reserve. Persisted in localStorage
 * until the cash-flow API is wired.
 */
export const cashAccountsAtom = atomWithStorage<CashAccounts>(
  "cashflow.accounts",
  defaultCashAccounts(),
  undefined,
  { getOnInit: true },
);
